import { gql } from '@apollo/client';

export const postEsClientePersonaJuridica = gql`
mutation esClientePersonaJuridicaRQ{
    esClientePersonaJuridica(input:$input)  
    @rest(type: "esClientePersonaJuridicaRS", path: "/api/gateway/motorweb/validargenerico",method:"POST"){
            accion
            sge
            baseNegativa
            sucursal
            token      
    }
}
`